import styled from 'styled-components'

import { salmon } from '../../../styles/themeColors'

export const FloatingButtonContainer = styled.button`
  background-color: ${salmon};
  border: none;
  border-radius: 5px 5px 0 0;
  bottom: 50%;
  box-shadow: 0 0 10px 0 rgba(0, 0, 0, 0.3);
  color: white;
  height: fit-content;
  padding: 5px 25px 8px 25px;
  position: fixed;
  right: -70px;
  transform: rotate(-90deg);
  width: fit-content;
  z-index: 10;
  @media (max-width: 450px) {
    bottom: 0;
    border-radius: 0;
    padding: 10px 0;
    right: 0;
    transform: unset;
    width: 100%;
  }
`
